<template>
    <v-card>
        <v-container fluid grid-list-md>
            <v-layout row wrap border-rad-sm overflow-hidden align-center justify-center fill-height>
                <v-flex v-for="(tecnologia, index) in value[keyTecnologia]" :key="`tecnologia_${index}`" xs12 sm12 md6 class="elevation-0">
                    <card-basica-tecnologia-entrega :key-tecnologia="keyTecnologia" :prescripcion="value" :item="tecnologia" slot-entregas></card-basica-tecnologia-entrega>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
                default: null
            },
            keyTecnologia: {
                type: String,
                default: 'medicamentos'
            }
        },
        components: {
            CardBasicaTecnologiaEntrega: () => import('@/components/Prescripciones/ServiciosTecnologias/CardBasicaTecnologiaEntrega')
        }
    }
</script>

<style scoped>

</style>